import { Component, Injector, OnInit } from '@angular/core';
import { FormaEnvio } from 'src/app/model/geral/formaEnvio';
import { FormaEnvioService } from 'src/app/services/geral/forma-envio.service';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { GeralFormModule } from './geralform.module';

@Component({
  selector: 'app-form-formaenvio',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormFormaEnvioComponent extends FormGenerico<FormaEnvio> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: FormaEnvioService) 
  {
    super(injectorObj, api);
    this.obj = new FormaEnvio();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
